import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { HiOutlineSwitchVertical } from "react-icons/hi";
import { MdClose } from "react-icons/md";
import { VscSettingsGear } from "react-icons/vsc";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";

import CheckBoxField from "../form/checkBoxField";
import ContainedButton from "../form/containedButton";
import OutlinedButton from "../form/outlinedButton";
import RadioField from "../form/radioField";
import api from "services/api";
import { isObjectEmpty } from "utils/functions";
import {
  setUnitsList as setUnitsListDispatch,
  toggleSelectedUnit,
} from "store/actions/select-unit-actions";

import {
  AddressInButton,
  ButtonAddUnit,
  ButtonToggle,
  ButtonToggleContent,
  Container,
  ContentButtons,
  ContentForm,
  ContentIcons,
  ContentItem,
  ContentItemLabel,
  ContentItemLabelSubtitle,
  ContentItemLabelTitle,
  ContentItemLine,
  ContentItens,
  ContentOthersUnits,
  ContentRadio,
  ContentUnit,
  ContentUnits,
  ContentUpper,
  HrCustom,
  Line,
  LineHorizontal,
  ModalContainer,
  ModalContent,
  ModalHeader,
  ModalStyle,
  OldResident,
  SubtitleAddress,
  TextNotFound,
  TitleAddress,
  TitleOthersUnits,
  UnitOldResident,
  UnitSubtitleAddress,
  UnitTitleAddress,
} from "./styles";

const ChangeOfUnit = (): JSX.Element => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const ChangeOfUnitMenuRef = useRef(null);
  const ChangeOfToggleButton = useRef(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openModalSetting, setOpenModalSetting] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [selectedUnitChange, setSelectedUnitChange] = useState<any>({
    unitId: null,
    instanceId: null,
    name: null,
    dueDay: null,
    deliveryType: null,
    hasGasMeter: null,
    address: {
      fullAddress: null,
      address: null,
      number: null,
      complement: null,
      neighborhood: null,
      city: null,
      stateCode: null,
      zipCode: null,
      addressType: null,
    },
  });
  const { selectedUnit, unitsList: unitsListSelector } = useSelector(
    // @ts-ignore
    (state) => state.selectUnitReducer
  );
  const dispatch = useDispatch();

  const [newUnitsList, setNewUnitsList] = useState(unitsListSelector);
  const [unitsList, setUnitsList] = useState(unitsListSelector);

  const formik = useFormik({
    initialValues: {
      units: [],
    },
    onSubmit: async () => {
      try {
        const unitsIsUpdated = [];
        const headers = {
          access_token: localStorage.getItem(
            "@UltragazEmpresarial:accessToken"
          ),
        };

        unitsList?.map((unitData) => {
          const newUnitDataFind = newUnitsList?.find(
            (newUnitData) => newUnitData?.unitId === unitData?.unitId
          );

          if (unitData?.visibleUnit !== newUnitDataFind?.visibleUnit) {
            unitsIsUpdated.push(newUnitDataFind);
          }

          return unitData;
        });

        if (unitsIsUpdated?.length) {
          unitsIsUpdated?.map(async (unitData) => {
            await api.patch(
              `industrial/customer/v1/customers/me/unit-visibility/${unitData.unitId}?visible-value=${unitData?.visibleUnit}`,
              {},
              {
                headers,
              }
            );
          });

          dispatch(setUnitsListDispatch(newUnitsList));
          toast.success("Unidades alteradas com sucesso!");
        }
      } catch (err) {
        if (err.response) {
          const erro = err.response.data;
          if (erro) {
            const { message } = err.response.data;
            if (err.response.status !== 401) {
              toast.error(message);
            }
          } else if (err.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        } else {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      }
    },
  });

  const handleClickOutside = useCallback(
    (event) => {
      if (ChangeOfUnitMenuRef && ChangeOfToggleButton) {
        const { path } = event;
        if (
          !!path &&
          !path.includes(ChangeOfUnitMenuRef.current) &&
          !path.includes(ChangeOfToggleButton.current)
        ) {
          setOpenDrawer(false);
        }
      }
    },
    [ChangeOfToggleButton, ChangeOfUnitMenuRef]
  );

  const requestGetUnits = useCallback(async () => {
    setLoading(true);
    const accessToken = localStorage.getItem(
      "@UltragazEmpresarial:accessToken"
    );
    try {
      const headers = { access_token: accessToken };
      const response = await api.get(
        `industrial/customer/v1/customers/me/units`,
        { headers }
      );
      setLoading(false);
      const { data } = response;

      if (data.every((unit) => unit.visibleUnit === false)) {
        data[0].visibleUnit = true;
        const unitData = data[0];
        await api.patch(
          `industrial/customer/v1/customers/me/unit-visibility/${unitData.unitId}?visible-value=${unitData.visibleUnit}`,
          {},
          {
            headers,
          }
        );
      }

      const unitResponse = data.filter((unit) => unit.visibleUnit === true);

      if (data && data.length > 0) {
        const unitFilted = data.filter(
          (unit) => selectedUnit.unitId === unit.unitId
        );
        if (!selectedUnit.unitId || !unitFilted.length) {
          dispatch(toggleSelectedUnit(unitResponse[0]));
        } else {
          const unitSelectedIndex = data.findIndex(
            (unit) => selectedUnit.unitId === unit.unitId
          );
          if (unitSelectedIndex >= 0) {
            dispatch(toggleSelectedUnit(data[unitSelectedIndex]));
          }
        }
      }
      dispatch(setUnitsListDispatch(data));
    } catch (err) {
      setLoading(false);
      const erro = err.response;
      if (erro) {
        const { message } = err.response.data;
        if (err.response.status !== 401) {
          toast.error(message);
        }
      } else if (err.response.status !== 401) {
        toast.error("Ocorreu um erro interno na aplicação");
      }
    }
  }, [api, selectedUnit, dispatch, toggleSelectedUnit, setLoading, unitsList]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    requestGetUnits();
  }, []);

  useEffect(() => {
    if (selectedUnit) {
      setSelectedUnitChange(selectedUnit);
    }
  }, [selectedUnit]);

  const handleSwitchUnit = useCallback(
    (unit) => {
      dispatch(toggleSelectedUnit(unit));
      setOpenDrawer(false);
      localStorage.removeItem("twilio-flex-cf");
      history.push("/portal");
      window.location.reload();
    },
    [dispatch, toggleSelectedUnit, selectedUnit]
  );

  const addressSkipTo = useMemo(() => {
    const { address } = selectedUnit;
    if (selectedUnit && selectedUnit.address.length > 0) {
      return address.find((ad) => ad.addressType === "SHIP_TO");
    }
    return {};
  }, [selectedUnit]);

  const handleShipTOAddress = useCallback((address) => {
    if (address && address.length)
      return address.find((ad) => ad.addressType === "SHIP_TO") || {};
    return {};
  }, []);

  const handleFullAdrress = useCallback((address) => {
    if (!isObjectEmpty(address)) {
      return `${address.address || address.fullAddress}${
        address.number ? `, ${address.number}` : ""
      }${address.complement ? `, ${address.complement}` : ""}${
        address.neighborhood ? `, ${address.neighborhood}` : ""
      }${address.city ? `, ${address.city}` : ""}${
        address.stateCode ? `-${address.stateCode}` : ""
      }${address.zipCode ? `, ${address.zipCode}` : ""}`;
    }
    return "";
  }, []);

  const fullAddress = useMemo(() => {
    return handleFullAdrress(addressSkipTo);
  }, [addressSkipTo, isObjectEmpty]);

  const toggleOpenDrawer = (): void => {
    setOpenDrawer((prevState) => !prevState);
  };

  const toggleOpenModalSetting = (): void => {
    setOpenModalSetting((prevState) => !prevState);
    requestGetUnits();
    setSelectedFilter("all");
  };

  const onSelectFilter = (e): void => {
    setSelectedFilter(e?.target?.value);
  };

  const list = useMemo(() => {
    const listAll = newUnitsList?.map((unit) => {
      const address =
        unit?.address?.find((ad) => ad.addressType === "SHIP_TO") || {};

      return {
        ...unit,
        address,
      };
    });

    if (selectedFilter === "all") {
      return listAll;
    }

    if (selectedFilter === "notVisible") {
      return listAll.filter((unit) => unit?.visibleUnit === false);
    }

    return listAll.filter((unit) => unit?.visibleUnit === true);
  }, [selectedFilter, newUnitsList]);

  useEffect(() => {
    setNewUnitsList(unitsListSelector);
    setUnitsList(unitsListSelector);
  }, [unitsListSelector]);

  useEffect(() => {
    const unitsVisible = newUnitsList
      ?.filter((unit) => unit?.visibleUnit)
      ?.map((unit) => unit?.unitId);

    formik.setFieldValue("units", unitsVisible);
  }, [selectedFilter, newUnitsList]);

  const updatedUnit = (id, value): void => {
    const newData = newUnitsList?.map((unitData) => {
      if (id === unitData?.unitId) {
        return {
          ...unitData,
          visibleUnit: value,
        };
      }

      return unitData;
    });

    setNewUnitsList(newData);
  };

  return (
    <>
      <Container>
        <ButtonToggle onClick={toggleOpenDrawer} ref={ChangeOfToggleButton}>
          <ButtonToggleContent>
            {loading ? (
              <span>Carregando...</span>
            ) : (
              <AddressInButton>
                <TitleAddress>
                  {selectedUnitChange.condominiumName
                    ? selectedUnitChange.condominiumName
                    : addressSkipTo && fullAddress}
                </TitleAddress>
                <SubtitleAddress>
                  {selectedUnitChange?.address?.length &&
                    addressSkipTo.complement}
                </SubtitleAddress>
              </AddressInButton>
            )}
            <ContentIcons>
              <VscSettingsGear onClick={toggleOpenModalSetting} size={16} />
              <Line />
              <HiOutlineSwitchVertical size={16} />
            </ContentIcons>
          </ButtonToggleContent>
          {!selectedUnit?.hasCurrentHouseholder && (
            <OldResident>(morador antigo)</OldResident>
          )}
          <ButtonAddUnit
            to="/adicionar-unidade"
            onClick={() => setOpenDrawer(false)}
          >
            <AiOutlinePlus />
            <span>Adicionar unidade</span>
          </ButtonAddUnit>
        </ButtonToggle>

        <ContentUpper show={openDrawer}>
          <ContentOthersUnits>
            <HrCustom />
            <TitleOthersUnits>Condomínios cadastrados:</TitleOthersUnits>
            <ContentUnits>
              {unitsList
                ?.filter((unit) => !!unit.visibleUnit)
                ?.map((unit) => {
                  const address =
                    unit?.address?.find((ad) => ad.addressType === "SHIP_TO") ||
                    {};

                  return (
                    <ContentUnit
                      key={unit.unitId}
                      selected={selectedUnitChange.unitId === unit.unitId}
                      onClick={() => handleSwitchUnit(unit)}
                    >
                      <UnitTitleAddress>
                        {unit.condominiumName || handleFullAdrress(address)}
                      </UnitTitleAddress>
                      <UnitSubtitleAddress>
                        {handleShipTOAddress(unit.address).complement}
                      </UnitSubtitleAddress>
                      {!unit?.hasCurrentHouseholder && (
                        <UnitOldResident
                          selected={selectedUnitChange.unitId === unit.unitId}
                        >
                          (morador antigo)
                        </UnitOldResident>
                      )}
                    </ContentUnit>
                  );
                })}
            </ContentUnits>
          </ContentOthersUnits>
          <ButtonAddUnit
            to="/adicionar-unidade"
            onClick={() => setOpenDrawer(false)}
          >
            <AiOutlinePlus />
            <span>Adicionar unidade</span>
          </ButtonAddUnit>
        </ContentUpper>
      </Container>
      <ModalStyle
        show={openModalSetting}
        onHide={toggleOpenModalSetting}
        centered
        backdrop="static"
      >
        <ModalContainer>
          <ModalHeader>
            <div>
              <div>
                <h2>Gerenciar unidades</h2>
                <span>
                  Selecione as unidades que você gostaria de continuar
                  visualizando o histórico
                </span>
              </div>
              <MdClose size={24} onClick={toggleOpenModalSetting} />
            </div>
          </ModalHeader>
          <ModalContent>
            <ContentForm onSubmit={formik.handleSubmit}>
              <ContentRadio>
                <RadioField
                  value="all"
                  name="filter"
                  id="all"
                  onChange={onSelectFilter}
                  defaultChecked
                >
                  Todas unidades
                </RadioField>
                <RadioField
                  value="visible"
                  name="filter"
                  id="visible"
                  onChange={onSelectFilter}
                >
                  Unidades visíveis
                </RadioField>
                <RadioField
                  value="notVisible"
                  name="filter"
                  id="notVisible"
                  onChange={onSelectFilter}
                >
                  Unidades ocultas
                </RadioField>
              </ContentRadio>
              <LineHorizontal />
              <ContentItens>
                {list?.map((unit) => {
                  return (
                    <ContentItem
                      isDisabled={
                        unit.unitId === selectedUnit.unitId ||
                        (list?.length === 1 && selectedFilter === "all")
                      }
                      key={unit.unitId}
                    >
                      <CheckBoxField
                        name="units"
                        id={unit.unitId}
                        value={unit.unitId}
                        onChange={(e) => {
                          const isChecked = formik.values.units?.find(
                            (unitId) => unit.unitId === unitId
                          );
                          updatedUnit(unit.unitId, !isChecked);
                          formik.handleChange(e);
                        }}
                        checked={
                          !!formik.values.units?.find(
                            (unitId) => unit.unitId === unitId
                          )
                        }
                        disabled={
                          unit.unitId === selectedUnit.unitId ||
                          (list?.length === 1 && selectedFilter === "all")
                        }
                      />
                      <ContentItemLine />
                      <ContentItemLabel>
                        <ContentItemLabelTitle>
                          {unit.condominiumName ||
                            handleFullAdrress(unit.address)}
                        </ContentItemLabelTitle>
                        <ContentItemLabelSubtitle>
                          {unit.address.complement}
                        </ContentItemLabelSubtitle>
                      </ContentItemLabel>
                    </ContentItem>
                  );
                })}

                {!list?.length && (
                  <TextNotFound>Não existem dados para exibição.</TextNotFound>
                )}
              </ContentItens>
              <LineHorizontal />
              <ContentButtons>
                <OutlinedButton onClick={toggleOpenModalSetting}>
                  Cancelar
                </OutlinedButton>
                <ContainedButton
                  type="submit"
                  loading={formik.isSubmitting}
                  disabled={formik.isSubmitting}
                >
                  Salvar
                </ContainedButton>
              </ContentButtons>
            </ContentForm>
          </ModalContent>
        </ModalContainer>
      </ModalStyle>
    </>
  );
};

export default ChangeOfUnit;
